
	import Vue, { PropType } from 'vue';
	import Component, { mixins } from 'vue-class-component';
	import { customizable, Options } from '@cnamts/vue-dot/src/mixins/customizable';
	import { PeriodValue } from '@cnamts/vue-dot/src/patterns/PeriodField/types';
	import { config } from '@cnamts/vue-dot/src/patterns/PeriodField/config';
	import deepMerge from 'deepmerge';
	import advancedSearch from '@/translations/fr/components/globals/advancedSearch';

	const Props = Vue.extend({
		props: {
			value: {
				type: Object as PropType<PeriodValue>,
				default: () => ({
					from: null,
					to: null
				})
			},
			outlined: {
				type: Boolean,
				default: false
			},
			disabled: {
				type: Boolean,
				default: false
			},
			label: {
				type: String,
				default: ''
			}
		}
	});

	const MixinsDeclaration = mixins(Props, customizable(config));

	@Component<CustomPeriodField>({
		model: {
			prop: 'value',
			event: 'change'
		},
		watch: {
			value: {
				handler(value: PeriodValue): void {
					if (value) {
						this.periodValue = value;

						return;
					}

					this.periodValue = {
						from: null,
						to: null
					};

				},
				immediate: true,
				deep: true
			}
		}
	})
	export default class CustomPeriodField extends MixinsDeclaration {
		periodValue = {} as PeriodValue;

		get datePickerOptions(): Options {
			return deepMerge<Options>(config, this.options);
		}

		updateDateRange(): void {
			this.formatPeriodValue();
			this.$emit('change', this.periodValue);
		}

		dateRangeRules = [
			() => this.isValidRange() || advancedSearch.chip.dateRange.fromGreaterThanTo
		];

		isValidRange(): boolean {
			this.formatPeriodValue();

			return (null === this.periodValue.from || null === this.periodValue.to) || new Date(this.periodValue.from) <= new Date(this.periodValue.to);
		}

		formatPeriodValue(): void {
			this.periodValue.from = '' !== this.periodValue.from ? this.periodValue.from : null;
			this.periodValue.to = '' !== this.periodValue.to ? this.periodValue.to : null;
		}
	}
